var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconOpenReturnLeg = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9.53025 14.7803C9.82275 14.4878 9.82275 14.0123 9.53025 13.7198L7.0605 11.25L9.53025 8.78028C9.82275 8.48778 9.82275 8.01228 9.53025 7.71978C9.23775 7.42728 8.76225 7.42653 8.46975 7.71978L5.46975 10.7198C5.1765 11.0123 5.1765 11.4878 5.46975 11.7803L8.46975 14.7803C8.76225 15.0728 9.23775 15.0728 9.53025 14.7803Z", fill: "black" }),
            React.createElement("path", { d: "M18 10.5H17.25C16.836 10.5 16.5 10.836 16.5 11.25C16.5 11.664 16.836 12 17.25 12H18C18.414 12 18.75 11.664 18.75 11.25C18.75 10.836 18.414 10.5 18 10.5Z", fill: "black" }),
            React.createElement("path", { d: "M13.5 10.5H14.25C14.664 10.5 15 10.836 15 11.25C15 11.664 14.664 12 14.25 12H13.5C13.086 12 12.75 11.664 12.75 11.25C12.75 10.836 13.086 10.5 13.5 10.5Z", fill: "black" }),
            React.createElement("path", { d: "M9 11.25C9 11.664 9.336 12 9.75 12H10.5C10.914 12 11.25 11.664 11.25 11.25C11.25 10.836 10.914 10.5 10.5 10.5H9.75C9.336 10.5 9 10.836 9 11.25Z", fill: "black" }))),
        alt: 'OpenReturnLeg',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconOpenReturnLeg;
//# sourceMappingURL=index.js.map